import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineAbilityConfig} from '../system/defineAbilityConfig';

export const canUsePluginAssetStore = defineAbilityConfig([
  {
    featureFlags: {[FEATURE_FLAGS.PLUGIN_STORE_CONVERSION]: true},
  },
]);
